import * as React from "react"
import { SVGProps } from "react"

const MoscowPoints = (props: SVGProps<SVGSVGElement>) => (
	<svg
		{...props}
		width="301"
		height="200"
		viewBox="0 0 301 200"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="150.5"
			cy="111.782"
			r="84"
			fill="white"
			stroke="#2A2D33"
			strokeWidth="2"
		/>
		<mask
			id="mask0_12678_270735"
			mask-type="alpha"
			maskUnits="userSpaceOnUse"
			x="66"
			y="4"
			width="169"
			height="192"
		>
			<path
				d="M66.5 4.21826H234.5V111.782C234.5 158.174 196.892 195.782 150.5 195.782C104.108 195.782 66.5 158.174 66.5 111.782V4.21826Z"
				fill="#A86363"
			/>
		</mask>
		<g mask="url(#mask0_12678_270735)">
			<path
				d="M173.109 94.229C173.109 95.5324 174.756 98.0663 180.469 102.978C185.809 107.569 184.398 111.532 182.194 113.791C181.185 114.825 179.706 115.158 178.262 115.158H171.608"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M97.5026 99.1535C93.842 96.9672 88.7172 90.7064 97.5026 83.1535C105.007 76.7019 107.171 73.3734 107.171 71.6611M97.5026 99.1535H112.502M97.5026 99.1535V108.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M116.84 99.1535C120.501 96.9672 125.626 90.7064 116.84 83.1535C109.336 76.7019 107.172 73.3734 107.171 71.6611"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M203.498 99.1535C207.159 96.9672 212.284 90.7064 203.498 83.1535C195.994 76.7019 193.83 73.3734 193.83 71.6611M203.498 99.1535H188.499M203.498 99.1535V108.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M184.161 99.1535C180.5 96.9672 175.375 90.7064 184.161 83.1535C191.665 76.7019 193.829 73.3734 193.83 71.6611"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M100.841 116.848C100.841 113.902 98.4527 111.514 95.5068 111.514V124.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M111.509 116.848C111.509 113.902 113.897 111.514 116.843 111.514"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M100.841 116.848C100.841 113.902 103.229 111.514 106.175 111.514C109.121 111.514 111.509 113.902 111.509 116.848"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M127.892 94.229C127.891 95.5324 126.244 98.0663 120.531 102.978C115.191 107.569 116.602 111.532 118.807 113.791C119.815 114.825 121.294 115.158 122.738 115.158H129.368"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M150.497 78.2402C150.497 79.5437 152.145 82.0776 157.858 86.9888C163.198 91.5798 161.787 95.5437 159.582 97.8021C158.573 98.8359 157.095 99.1689 155.65 99.1689H147.961"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M150.497 78.2402C150.497 79.5437 148.849 82.0776 143.137 86.9888C137.796 91.5798 139.208 95.5437 141.412 97.8021C142.421 98.8359 143.899 99.1689 145.344 99.1689H153.033"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
			/>
			<path
				d="M200.16 116.848C200.16 113.902 202.548 111.514 205.494 111.514V124.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M189.492 116.848C189.492 113.902 187.104 111.514 184.158 111.514"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M200.16 116.848C200.16 113.902 197.772 111.514 194.826 111.514C191.88 111.514 189.492 113.902 189.492 116.848"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M150.497 73.2245C150.497 70.1721 148.023 67.6978 144.971 67.6978C141.918 67.6978 139.444 70.1721 139.444 73.2245"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M230.497 163.153L220.497 139.153L210.497 163.153H230.497Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M144.466 80.7513C144.466 77.699 141.992 75.2246 138.94 75.2246C135.889 75.2246 133.415 77.699 133.415 80.7513V91.1533"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M156.532 80.7513C156.532 77.699 159.006 75.2246 162.058 75.2246C165.111 75.2246 167.585 77.699 167.585 80.7513V91.1533"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M200.457 155.725L194.828 139.153L190.062 153.452L200.457 155.725Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M200.162 139.153L194.828 123.153L189.495 139.153H200.162Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M205.494 139.153V123.153L200.161 139.153H205.494Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M205.493 139.153V152.571"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M184.162 139.153V123.153L189.495 139.153H184.162Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="210.497"
				y="163.153"
				width="20"
				height="20"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M161.55 73.2245C161.55 70.1721 159.076 67.6978 156.023 67.6978C152.971 67.6978 150.497 70.1721 150.497 73.2245"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="179.159"
				y="163.153"
				width="31.3384"
				height="20"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<rect
				x="121.836"
				y="163.153"
				width="57.3228"
				height="20"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M179.159 151.166L212.501 158.345L210.497 163.153H179.159V151.166Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<rect
				x="121.836"
				y="151.153"
				width="57.3228"
				height="12"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M189.495 166.153V183.153H200.161V166.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M100.842 166.153V183.153H111.509V166.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M215.497 180.153V174.153C215.497 171.392 217.736 169.153 220.497 169.153V169.153C223.258 169.153 225.497 171.392 225.497 174.153V183.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M171.608 139.153H204.497"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M70.5029 163.153L80.5029 139.153L90.5029 163.153H70.5029Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M147.396 31.8156C146.984 31.5952 146.601 31.33 146.255 31.0235C145.13 30.0259 144.498 28.6729 144.498 27.2622C144.498 25.0773 145.637 23.4397 147.026 21.4444L147.026 21.4442C148.107 19.8923 149.337 18.124 150.3 15.7135C150.356 15.5726 150.496 15.1533 150.496 15.1533L150.497 15.156L150.498 15.1533C150.498 15.1533 150.639 15.5726 150.695 15.7135C151.657 18.124 152.888 19.8923 153.968 21.4442L153.968 21.4446C155.357 23.4398 156.497 25.0774 156.497 27.2622C156.497 28.6729 155.865 30.0259 154.74 31.0235C154.396 31.3284 154.011 31.5932 153.598 31.8137L161.55 59.1533H139.444L147.396 31.8156Z"
				fill="white"
			/>
			<path
				d="M147.396 31.8156L148.356 32.0949C148.488 31.6412 148.284 31.1571 147.868 30.934L147.396 31.8156ZM146.255 31.0235L146.918 30.2753L146.918 30.2752L146.255 31.0235ZM147.026 21.4444L146.206 20.873L146.205 20.8731L147.026 21.4444ZM147.026 21.4442L147.847 22.0156L147.847 22.0155L147.026 21.4442ZM150.3 15.7135L151.228 16.0842L151.229 16.0841L150.3 15.7135ZM150.496 15.1533L151.443 14.8309C151.305 14.4248 150.923 14.1522 150.494 14.1533C150.065 14.1544 149.684 14.429 149.548 14.8358L150.496 15.1533ZM150.497 15.156L149.551 15.4784C149.689 15.8835 150.069 16.1559 150.497 16.156C150.925 16.156 151.306 15.8838 151.444 15.4787L150.497 15.156ZM150.498 15.1533L151.446 14.8358C151.31 14.4291 150.93 14.1545 150.501 14.1533C150.072 14.1521 149.69 14.4246 149.552 14.8306L150.498 15.1533ZM150.695 15.7135L149.766 16.0841L149.766 16.0842L150.695 15.7135ZM153.968 21.4442L154.79 20.874L154.789 20.8729L153.968 21.4442ZM153.968 21.4446L153.147 22.0149L153.148 22.0159L153.968 21.4446ZM154.74 31.0235L155.403 31.7717V31.7717L154.74 31.0235ZM153.598 31.8137L153.127 30.9313C152.71 31.154 152.506 31.6387 152.638 32.093L153.598 31.8137ZM161.55 59.1533V60.1533C161.865 60.1533 162.161 60.0052 162.35 59.7536C162.539 59.502 162.598 59.1761 162.51 58.874L161.55 59.1533ZM139.444 59.1533L138.484 58.874C138.396 59.1761 138.455 59.502 138.644 59.7536C138.833 60.0052 139.129 60.1533 139.444 60.1533V59.1533ZM147.868 30.934C147.522 30.7492 147.204 30.5282 146.918 30.2753L145.591 31.7717C145.997 32.1318 146.446 32.4413 146.924 32.6972L147.868 30.934ZM146.918 30.2752C145.991 29.4533 145.498 28.3662 145.498 27.2622H143.498C143.498 28.9797 144.268 30.5985 145.591 31.7717L146.918 30.2752ZM145.498 27.2622C145.498 25.4427 146.423 24.0612 147.847 22.0156L146.205 20.8731C144.852 22.8181 143.498 24.7119 143.498 27.2622H145.498ZM147.847 22.0157L147.847 22.0156L146.206 20.8729L146.206 20.873L147.847 22.0157ZM147.847 22.0155C148.928 20.4633 150.219 18.612 151.228 16.0842L149.371 15.3427C148.455 17.636 147.286 19.3213 146.206 20.8729L147.847 22.0155ZM151.229 16.0841C151.267 15.9868 151.325 15.8223 151.365 15.7059C151.387 15.6426 151.406 15.584 151.421 15.5414C151.428 15.5201 151.434 15.5026 151.438 15.4904C151.44 15.4843 151.442 15.4795 151.443 15.4762C151.443 15.4745 151.444 15.4732 151.444 15.4723C151.444 15.4719 151.444 15.4715 151.444 15.4713C151.444 15.4711 151.445 15.471 151.445 15.471C151.445 15.4709 151.445 15.4709 151.445 15.4709C151.445 15.4709 151.445 15.4708 151.445 15.4708C151.445 15.4708 151.445 15.4708 150.496 15.1533C149.548 14.8358 149.548 14.8358 149.548 14.8358C149.548 14.8358 149.548 14.8358 149.548 14.8358C149.548 14.8358 149.548 14.8358 149.548 14.8358C149.548 14.8359 149.548 14.8359 149.548 14.836C149.548 14.8361 149.548 14.8364 149.548 14.8367C149.548 14.8374 149.547 14.8385 149.547 14.84C149.546 14.8429 149.544 14.8472 149.542 14.8528C149.539 14.8641 149.533 14.8805 149.526 14.9006C149.513 14.941 149.494 14.9961 149.474 15.0552C149.429 15.1837 149.388 15.2993 149.371 15.3429L151.229 16.0841ZM149.55 15.4757L149.551 15.4784L151.444 14.8336L151.443 14.8309L149.55 15.4757ZM151.444 15.4787L151.445 15.476L149.552 14.8306L149.551 14.8333L151.444 15.4787ZM150.498 15.1533C149.55 15.4708 149.55 15.4708 149.55 15.4708C149.55 15.4708 149.55 15.4709 149.55 15.4709C149.55 15.4709 149.55 15.4709 149.55 15.471C149.55 15.471 149.55 15.4711 149.55 15.4713C149.55 15.4715 149.55 15.4719 149.55 15.4723C149.551 15.4732 149.551 15.4745 149.552 15.4762C149.553 15.4795 149.554 15.4843 149.556 15.4904C149.561 15.5026 149.566 15.5201 149.574 15.5414C149.588 15.584 149.608 15.6426 149.63 15.7059C149.67 15.8223 149.727 15.9868 149.766 16.0841L151.624 15.3429C151.606 15.2993 151.565 15.1837 151.521 15.0552C151.501 14.9961 151.482 14.941 151.468 14.9006C151.461 14.8805 151.456 14.8641 151.452 14.8528C151.45 14.8472 151.449 14.8429 151.448 14.84C151.447 14.8385 151.447 14.8374 151.447 14.8367C151.447 14.8364 151.447 14.8361 151.446 14.836C151.446 14.8359 151.446 14.8359 151.446 14.8358C151.446 14.8358 151.446 14.8358 151.446 14.8358C151.446 14.8358 151.446 14.8358 151.446 14.8358C151.446 14.8358 151.446 14.8358 150.498 15.1533ZM149.766 16.0842C150.775 18.612 152.067 20.4633 153.147 22.0155L154.789 20.8729C153.709 19.3213 152.539 17.636 151.623 15.3427L149.766 16.0842ZM153.147 22.0145L153.147 22.0149L154.79 20.8743L154.79 20.874L153.147 22.0145ZM153.148 22.0159C154.571 24.0613 155.497 25.4428 155.497 27.2622H157.497C157.497 24.712 156.143 22.8183 154.789 20.8733L153.148 22.0159ZM155.497 27.2622C155.497 28.3662 155.003 29.4533 154.076 30.2752L155.403 31.7717C156.726 30.5985 157.497 28.9797 157.497 27.2622H155.497ZM154.076 30.2752C153.794 30.5255 153.475 30.746 153.127 30.9313L154.068 32.6961C154.548 32.4404 154.998 32.1312 155.403 31.7717L154.076 30.2752ZM162.51 58.874L154.558 31.5344L152.638 32.093L160.59 59.4326L162.51 58.874ZM139.444 60.1533H161.55V58.1533H139.444V60.1533ZM146.435 31.5363L138.484 58.874L140.404 59.4326L148.356 32.0949L146.435 31.5363Z"
				fill="#2A2D33"
			/>
			<path
				d="M156.192 151.149L150.497 123.153L144.802 151.149H156.192Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M144.802 151.149L139.107 123.153L133.413 151.149H144.802Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M167.581 151.149L161.887 123.153L156.192 151.149H167.581Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M100.543 155.725L106.172 139.153L110.938 153.452L100.543 155.725Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M100.838 139.153L106.172 123.153L111.505 139.153H100.838Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.5055 139.153V123.153L100.839 139.153H95.5055Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M95.5068 139.153V152.571"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M116.838 139.153V123.153L111.505 139.153H116.838Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				width="20"
				height="20"
				transform="matrix(-1 0 0 1 90.5029 163.153)"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M161.55 75.2245V59.1533H139.444V75.2245"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M133.415 91.1533V151.165H167.585V91.1533"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M157.819 111.181V99.1689H143.175V111.181"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				width="31.3384"
				height="20"
				transform="matrix(-1 0 0 1 121.841 163.153)"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M121.841 151.166L88.499 158.345L90.5029 163.153H121.841V151.166Z"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinejoin="round"
			/>
			<path
				d="M138.413 180.153V174.153C138.413 171.392 136.174 169.153 133.413 169.153V169.153C130.651 169.153 128.413 171.392 128.413 174.153V183.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M107.171 71.6978V65.6978"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M162.585 180.153V174.153C162.585 171.392 164.824 169.153 167.585 169.153V169.153C170.346 169.153 172.585 171.392 172.585 174.153V183.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M85.5029 180.153V174.153C85.5029 171.392 83.2644 169.153 80.5029 169.153V169.153C77.7415 169.153 75.5029 171.392 75.5029 174.153V183.153"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M129.43 139.153H96.5032"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M136.497 59.1533H164.497"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M133.413 115.158H167.582"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M193.83 71.6978V65.6978"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M150.497 15.1533V9.15332"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M150.497 59.1533V36.1533"
				stroke="#2A2D33"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</g>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M95.2355 37.4457C95.7362 37.6631 96.3371 37.5183 96.6631 37.0804C98.7298 34.3049 102.036 32.5071 105.763 32.5071C112.025 32.5071 117.101 37.5832 117.101 43.845C117.101 43.9038 117.1 43.9626 117.099 44.0212C117.091 44.5707 117.488 45.0508 118.012 45.2156C120.081 45.866 121.581 47.799 121.581 50.0824C121.581 52.8994 119.297 55.1831 116.48 55.1831H79.4291C76.612 55.1831 74.3284 52.8994 74.3284 50.0824C74.3284 47.2654 76.612 44.9817 79.4291 44.9817H83.9933C84.227 44.9817 84.4119 44.7853 84.4119 44.5515C84.4119 40.2752 87.8785 36.8086 92.1548 36.8086C93.2496 36.8086 94.2914 37.0359 95.2355 37.4457Z"
			fill="white"
		/>
		<path
			d="M95.8611 36.4832C98.1083 33.4651 101.707 31.5071 105.763 31.5071V33.5071C102.366 33.5071 99.3513 35.1446 97.4652 37.6776L95.8611 36.4832ZM105.763 31.5071C112.577 31.5071 118.101 37.0309 118.101 43.845H116.101C116.101 38.1355 111.472 33.5071 105.763 33.5071V31.5071ZM118.101 43.845C118.101 43.9089 118.1 43.9727 118.099 44.0365L116.1 44.006C116.1 43.9524 116.101 43.8988 116.101 43.845H118.101ZM118.312 44.2616C120.785 45.0392 122.581 47.3498 122.581 50.0824H120.581C120.581 48.2481 119.376 46.6927 117.712 46.1696L118.312 44.2616ZM122.581 50.0824C122.581 53.4517 119.85 56.1831 116.48 56.1831V54.1831C118.745 54.1831 120.581 52.3472 120.581 50.0824H122.581ZM116.48 56.1831H79.4291V54.1831H116.48V56.1831ZM79.4291 56.1831C76.0597 56.1831 73.3284 53.4517 73.3284 50.0824H75.3284C75.3284 52.3472 77.1643 54.1831 79.4291 54.1831V56.1831ZM73.3284 50.0824C73.3284 46.7131 76.0597 43.9817 79.4291 43.9817V45.9817C77.1643 45.9817 75.3284 47.8176 75.3284 50.0824H73.3284ZM79.4291 43.9817H83.9933V45.9817H79.4291V43.9817ZM92.1548 37.8086C88.4308 37.8086 85.4119 40.8275 85.4119 44.5515H83.4119C83.4119 39.723 87.3262 35.8086 92.1548 35.8086V37.8086ZM94.8372 38.363C94.0165 38.0067 93.1101 37.8086 92.1548 37.8086V35.8086C93.3892 35.8086 94.5663 36.065 95.6337 36.5285L94.8372 38.363ZM83.9933 43.9817C83.6397 43.9817 83.4119 44.2687 83.4119 44.5515H85.4119C85.4119 45.3019 84.8144 45.9817 83.9933 45.9817V43.9817ZM118.099 44.0365C118.099 44.0606 118.106 44.0991 118.144 44.1468C118.183 44.1967 118.243 44.24 118.312 44.2616L117.712 46.1696C116.828 45.8916 116.083 45.0594 116.1 44.006L118.099 44.0365ZM97.4652 37.6776C96.8476 38.5071 95.7415 38.7556 94.8372 38.363L95.6337 36.5285C95.6755 36.5466 95.7247 36.5506 95.7709 36.539C95.8158 36.5277 95.8445 36.5055 95.8611 36.4832L97.4652 37.6776Z"
			fill="#2A2D33"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M236.823 111.676C237.473 113.243 238.847 114.553 240.544 114.553H245.705C247.826 114.553 249.545 116.273 249.545 118.393C249.545 120.514 247.826 122.234 245.705 122.234H215.618C213.497 122.234 211.778 120.514 211.778 118.393C211.778 116.273 213.497 114.553 215.618 114.553C216.17 114.553 216.628 114.137 216.739 113.596C216.873 112.94 217.07 112.297 217.327 111.676C217.857 110.395 218.634 109.232 219.614 108.253C220.594 107.273 221.757 106.496 223.037 105.965C224.318 105.435 225.69 105.162 227.075 105.162C228.461 105.162 229.833 105.435 231.113 105.965C232.393 106.496 233.556 107.273 234.536 108.253C235.516 109.232 236.293 110.395 236.823 111.676Z"
			fill="white"
		/>
		<path
			d="M217.327 111.676L218.251 112.058V112.058L217.327 111.676ZM216.739 113.596L217.718 113.796L216.739 113.596ZM245.705 115.553H240.544V113.553H245.705V115.553ZM248.545 118.393C248.545 116.825 247.273 115.553 245.705 115.553V113.553C248.378 113.553 250.545 115.72 250.545 118.393H248.545ZM245.705 121.234C247.273 121.234 248.545 119.962 248.545 118.393H250.545C250.545 121.067 248.378 123.234 245.705 123.234V121.234ZM215.618 121.234H245.705V123.234H215.618V121.234ZM212.778 118.393C212.778 119.962 214.049 121.234 215.618 121.234V123.234C212.945 123.234 210.778 121.067 210.778 118.393H212.778ZM215.618 115.553C214.05 115.553 212.778 116.825 212.778 118.393H210.778C210.778 115.72 212.945 113.553 215.618 113.553V115.553ZM215.759 113.395C215.906 112.677 216.121 111.973 216.403 111.293L218.251 112.058C218.018 112.621 217.84 113.203 217.718 113.796L215.759 113.395ZM216.403 111.293C216.984 109.891 217.835 108.618 218.907 107.545L220.321 108.96C219.434 109.847 218.731 110.899 218.251 112.058L216.403 111.293ZM218.907 107.545C219.98 106.473 221.253 105.622 222.655 105.041L223.42 106.889C222.261 107.369 221.208 108.073 220.321 108.96L218.907 107.545ZM222.655 105.041C224.056 104.461 225.558 104.162 227.075 104.162V106.162C225.821 106.162 224.579 106.409 223.42 106.889L222.655 105.041ZM227.075 104.162C228.592 104.162 230.094 104.461 231.496 105.041L230.73 106.889C229.572 106.409 228.329 106.162 227.075 106.162V104.162ZM231.496 105.041C232.897 105.622 234.171 106.473 235.243 107.545L233.829 108.96C232.942 108.073 231.889 107.369 230.73 106.889L231.496 105.041ZM235.243 107.545C236.316 108.618 237.167 109.891 237.747 111.293L235.899 112.058C235.419 110.899 234.716 109.847 233.829 108.96L235.243 107.545ZM215.618 113.553C215.635 113.553 215.658 113.548 215.687 113.523C215.718 113.496 215.747 113.451 215.759 113.395L217.718 113.796C217.523 114.747 216.699 115.553 215.618 115.553V113.553ZM240.544 115.553C238.296 115.553 236.639 113.842 235.899 112.058L237.747 111.293C238.307 112.644 239.398 113.553 240.544 113.553V115.553Z"
			fill="#2A2D33"
		/>
	</svg>
)

export default MoscowPoints
